<script setup>
import AgencyFeesBonusElement from "@/components/dashboard/AgencyFeesBonusElement.vue";

const props = defineProps({
  progressElements: {
    type: Array,
    default: () => [],
  },
});

const isSpecialDivider = (progressElement, index) => {
  return (
    index !== props.progressElements.length - 1 &&
    props.progressElements[index + 1]?.type === "pending" &&
    progressElement?.type === "done"
  );
};
</script>

<template>
  <div class="agency-fees-progress-bar">
    <div
      v-for="(progressElement, index) in progressElements"
      :key="progressElement.id"
      :class="[
        'agency-fees-progress-bar__element',
        `agency-fees-progress-bar__element_${progressElement.type}`,
        {
          'agency-fees-progress-bar__element_special': isSpecialDivider(
            progressElement,
            index
          ),
        },
      ]"
    >
      <span class="divider" />

      <AgencyFeesBonusElement :bonus-element="progressElement" />

      <span class="divider" />
    </div>
  </div>
</template>

<style scoped lang="scss">
.agency-fees-progress-bar {
  padding: 20px 0;
  border-radius: 12px;
  background: #fff;
  display: grid;
  grid-template-columns: min-content 1fr min-content;

  .divider {
    display: block;
    min-width: 40px;

    @media (max-width: 767px) {
      min-width: 20px;
    }

    @media (max-width: 374px) {
      min-width: 10px;
    }
  }

  &__element {
    display: flex;
    align-items: center;
    justify-content: center;

    &_progress {
      > .divider:first-child {
        background-color: #ffda7a;
      }
    }

    &_done {
      > .divider {
        background-color: #ffda7a;
      }
    }

    &_special {
      > .divider {
        &:last-child {
          background-color: rgba(33, 33, 33, 0.1) !important;
        }
      }
    }
  }
}
</style>
